module.exports = "/_next/static/images/richard-matthews@2x-395fc92c32bf17e04560bc9e9e59eb8f.png";